import { Box, styled } from "@mui/material";

export const Card = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    boxShadow: theme.shadow.boxShadow.sm,
    borderRadius: theme.shape.borderRadius,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: theme.palette.core.grey._20,
    marginBottom: theme.spacing(3),
    minHeight: 160,

    [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
    },
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    backgroundColor: theme.palette.core.grey._20,
    padding: theme.spacing(2),
    height: 100,

    [theme.breakpoints.up("sm")]: {
        height: "unset",
        padding: theme.spacing(4),
        width: 240,
    },

    [theme.breakpoints.up("md")]: {
        width: 360,
    },
}));

export const ModelImage = styled("img")(({ theme }) => ({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    [theme.breakpoints.up("sm")]: {
        height: 128,
    },
}));

export const ChipContainer = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: 8,
    left: 0,
    display: "flex",
    gap: theme.spacing(1),
    backgroundColor: theme.palette.core.white,
    borderBottomRightRadius: 12,
    borderTopRightRadius: 12,
    height: 24,
    alignItems: "center",
    padding: theme.spacing(0, 2),
}));

export const BrandLogoContainer = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: 8,
    right: 8,
    height: 32,
}));

export const BrandLogoImage = styled("img")(({ theme }) => ({
    objectFit: "contain",
    height: 32,
    maxWidth: 70,
}));

export const ModelVariantContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    flex: 1,
}));

interface ModelVariantTouchableProps {
    showBorderBottom?: boolean;
}

export const ModelVariantTouchable = styled(Box, {
    shouldForwardProp: (prop) => prop !== "showBorderBottom",
})<ModelVariantTouchableProps>(({ theme, showBorderBottom }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 4),

    [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(4),
    },

    "&:hover": {
        backgroundColor: theme.palette.core.grey._20,
        cursor: "pointer",
    },
    ...(showBorderBottom && {
        borderBottom: `1px solid ${theme.palette.core.grey._20}`,
    }),
}));

export const ModelVariantRightContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(2),
}));
